import { Autocomplete, TextField, useTheme } from '@mui/material';
import { EquipmentConfig } from '@/generated';
import { useEquipmentListQuery } from '@/hooks/query-hooks';

export default function EquipmentAutocomplete(props: {
  optional?: boolean;
  selectedEquipment: Array<EquipmentConfig>;
  setSelectedEquipment: (ids: Array<EquipmentConfig>) => void;
}) {
  const { equipmentList } = useEquipmentListQuery();
  const { selectedEquipment, setSelectedEquipment } = props;
  const theme = useTheme();

  return (
    <Autocomplete
      multiple
      autoHighlight
      id="tags-outlined"
      value={equipmentList?.filter((eq) => selectedEquipment.some((e) => e.equipmentId === eq.id)) ?? []}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={(event, equipment) => {
        setSelectedEquipment(equipment.map((e) => ({ equipmentId: e.id, optional: props.optional ?? false })));
      }}
      options={equipmentList ?? []}
      getOptionLabel={(option) => option.name}
      filterSelectedOptions
      sx={{ minWidth: 200 }}
      slotProps={{ popper: { sx: { zIndex: theme.zIndex.modal + 2 } } }}
      renderInput={(params) => (
        <TextField
          variant="outlined"
          {...params}
          label={props.optional ? `Optional Equipment` : `Equipment`}
          placeholder={selectedEquipment.length === 0 ? (props.optional ? `Optional Equipment` : `Equipment`) : undefined}
        />
      )}
    />
  );
}
